@switch (site) {
  @case (sites.Healthlabs) {
    <app-healthlabs-layout>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-healthlabs-layout>
  }
  @case (sites.Stdcheck) {
    <app-stdcheck-layout>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-stdcheck-layout>
  }
  @case (sites.Treatmyuti) {
    <app-treatmyuti-layout>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-treatmyuti-layout>
  }
  @case (sites.Starfish) {
    <app-starfish-layout>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-starfish-layout>
  }
  @case (sites.Stallion) {
    <app-stallion-layout>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-stallion-layout>
  }
  @case (sites.TestosteroneHq) {
    <app-testosterone-hq-layout>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-testosterone-hq-layout>
  }
  @case (sites.AnalyteHealth) {
    <app-analytehealth-layout>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-analytehealth-layout>
  }
  @default {
    <ng-container *ngTemplateOutlet="content"></ng-container>
  }
}

<ng-template #content>
  <app-loading *ngIf="isLoading"></app-loading>
  <ng-container *ngIf="!isLoading">
    <app-phone-order-user-banner></app-phone-order-user-banner>
    <ng-content></ng-content>
  </ng-container>
</ng-template>
